var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "dashboards-maker--widget",
      class: { "dashboards-maker--widget__editing": _vm.isEditionMode },
      on: { mouseenter: _vm.handleMouseover, mouseleave: _vm.handleMouseout }
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.isEditionMode
        ? _c(
            "div",
            { staticClass: "dashboards-maker--widget__toolbox" },
            [
              _c("Button", {
                staticClass: "dashboards-maker--button__square",
                attrs: { icon: "edit" },
                nativeOn: {
                  click: function($event) {
                    return _vm.handleClickEdit($event)
                  }
                }
              }),
              _vm._v(" "),
              _c("Button", {
                staticClass: "dashboards-maker--button__square",
                attrs: { icon: "trash" },
                nativeOn: {
                  click: function($event) {
                    return _vm.handleClickDelete($event)
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }